interface Props {
  categoryName?: string;
  pageType?: string;
  price?: string | number;
  productName?: string;
  sku?: string;
}

const ConvertAB = ({
  categoryName = '',
  pageType = '',
  price = '',
  productName = '',
  sku = '',
}: Props) => {
  if (typeof window !== 'undefined') {
    window._conv_page_type = pageType;
    window._conv_category_id = '';
    window._conv_category_name = categoryName;
    window._conv_product_sku = sku;
    window._conv_product_name = productName;
    window._conv_product_price = price;
    window._conv_customer_id = '';
    window._conv_custom_v1 = '';
    window._conv_custom_v2 = '';
    window._conv_custom_v3 = '';
    window._conv_custom_v4 = '';
  }

  return null;
};

export default ConvertAB;
